var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPinWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_8558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.299 10.6993C21.299 17.7442 12.2413 23.7826 12.2413 23.7826C12.2413 23.7826 3.18359 17.7442 3.18359 10.6993C3.18359 8.29704 4.13788 5.99318 5.83653 4.29454C7.53518 2.59589 9.83904 1.6416 12.2413 1.6416C14.6435 1.6416 16.9474 2.59589 18.646 4.29454C20.3447 5.99318 21.299 8.29704 21.299 10.6993Z",
    fill: "#F4F4F8",
    stroke: "#F4F4F8",
    strokeWidth: 2.26442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2409 13.7182C13.9084 13.7182 15.2601 12.3664 15.2601 10.6989C15.2601 9.03144 13.9084 7.67969 12.2409 7.67969C10.5734 7.67969 9.22168 9.03144 9.22168 10.6989C9.22168 12.3664 10.5734 13.7182 12.2409 13.7182Z",
    fill: "#323232",
    stroke: "#323232",
    strokeWidth: 1.50962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_8558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1538,
    height: 24.1538,
    fill: "white",
    transform: "translate(0.164062 0.634766)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinWhite);
export default __webpack_public_path__ + "static/media/map-pin-white.572cacd9.svg";
export { ForwardRef as ReactComponent };